import { create } from '@bufbuild/protobuf';

import * as pbs from '@/grpc-gen/settings_service_pb';
import * as pbm from '@/grpc-gen/currency_pb';

export default class Currency {
  id: number = 0;

  code: string = 'N/A';

  hasDecimals: boolean = false;

  constructor(o?: { id?: number, code?: string, hasDecimals?: boolean }) {
    this.id = o?.id ?? 0;
    this.code = o?.code ?? 'N/A';
    this.hasDecimals = o?.hasDecimals ?? false;
  }

  static fromGrpcResponse(r: pbs.CurrencyResponse): Currency {
    return Currency.fromGrpcModel(r.currency);
  }

  static fromGrpcModel(o?: pbm.Currency): Currency {
    const e = new Currency();

    e.id = Number(o?.id ?? 0);
    e.code = o?.code ?? 'N/A';
    e.hasDecimals = o?.hasDecimals ?? false;

    return e;
  }

  toGrpcModel(): pbm.Currency {
    return create(pbm.CurrencySchema, {
      id: BigInt(this.id),
      code: this.code ?? 'N/A',
      hasDecimals: this.hasDecimals ?? false,
    });
  }

  get value() { return this.id; }

  get text() { return this.code; }
}
